/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import ReactSpeedometer from "react-d3-speedometer";
import DoughnutChart from "./DoughnutChart";
import { Legend, LiButton, SpinnerBlock } from "../Utils/CustomComponent";
import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import axios from "../axios";
import urls from "../Utils/urls";
import { useNavigate } from "react-router-dom";
import {
  setLoanAgingTab,
  setMeterDetails,
} from "../store/reducers/dashboardSlice";
import * as _ from "lodash";
import moment from "moment";
import { reduceSum } from "../Utils";
import { useAbortController } from "../hooks/useAbortController";
import { loadingTypes } from "../Utils/constant";

const DoughnutAndMeter = () => {
  const dispatch = useDispatch();
  const loanAgingTab = useSelector(
    (state) => state.dashboard.kpis.loanAgingTab
  );
  const handleActiveTab = (value) => {
    dispatch(setLoanAgingTab(value));
  };
  return (
    <div className="col-xl-5 col-lg-12 bg-white p-3 rounded">
      <ul className="nav nav-tabs bg-white">
        {tabConfig?.map((data, index) => (
          <LiButton
            key={index}
            activeTab={loanAgingTab}
            setActiveTab={handleActiveTab}
            label={data.label}
            value={index}
          />
        ))}
      </ul>
      <div className="d-flex justify-content-center align-items-center">
        {tabConfig?.[loanAgingTab]?.renderComponent()}
      </div>
    </div>
  );
};

export default DoughnutAndMeter;
const Meter = () => {
  const [formData, setFormData] = useState({
    finalPrincipal: 0,
    riskFactor: 0,
    segment: 0,
    LoanCount: 0,
    loanInsured: 0,
    insExpirationWithin30Days: 0,
  });
  const kpis = useSelector((state) => state.dashboard.kpis);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const accountId = useSelector((state) => state.account.lenderId);
  const portfolioAtGlanceData = useSelector(
    (state) => state.dashboard?.portfolioAtGlance?.data
  );
  const portfolioAtGlanceStatus = useSelector(
    (state) => state.dashboard?.portfolioAtGlance?.status
  );
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          urls.dashboard.getInsuranceMonitoring(accountId),
          { signal }
        );

        if (data?.[0]?.length) {
          const accountValues = portfolioAtGlanceData.map(({ account }) =>
            account.trim().toLowerCase()
          );

          const filteredInsuranceData = data?.[0].filter(({ Account }) =>
            accountValues.includes(Account.trim().toLowerCase())
          );
          const uniqueInsuranceFilterdArr = filteredInsuranceData.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.Account === item.Account)
          );
          const thirtyDaysMoment = moment().add(30, "days");

          if (filteredInsuranceData.length) {
            const updatedFilteredInsuranceData = filteredInsuranceData.map(
              (el) => ({
                ...el,
                PropAddress: `${el.PropCounty}, ${el.PropZip}`,
              })
            );
            dispatch(setMeterDetails(updatedFilteredInsuranceData));

            const finalPrincipal = reduceSum(
              uniqueInsuranceFilterdArr.map(
                (item) => item?.["Lender Principal Investment"]
              )
            );
            const insuranceExpireIn30DaysArr = filteredInsuranceData
              .filter(({ InsExpiration }) =>
                moment(InsExpiration).isBetween(
                  moment(),
                  thirtyDaysMoment,
                  null,
                  "[]"
                )
              )
              .filter(
                (item, index, self) =>
                  index === self.findIndex((t) => t.Account === item.Account)
              );
            const sumOfInsExpirationWithin30Days = reduceSum(
              insuranceExpireIn30DaysArr.map(
                (item) => item?.["Lender Principal Investment"]
              )
            );
            const riskFactor =
              Number(
                (sumOfInsExpirationWithin30Days / finalPrincipal).toFixed(2)
              ) * 100;

            setFormData({
              finalPrincipal: sumOfInsExpirationWithin30Days,
              riskFactor,
              segment:
                sumOfInsExpirationWithin30Days === 0
                  ? 100
                  : getSegment(riskFactor),
              LoanCount: portfolioAtGlanceData.length,
              loanInsured: uniqueInsuranceFilterdArr.length || 0,
              insExpirationWithin30Days: insuranceExpireIn30DaysArr.length,
              status: loadingTypes.fulfilled,
            });
          } else {
            setFormData({
              ...formData,
              // segment: 100,
              segment: 0,
              loanInsured: uniqueInsuranceFilterdArr.length || 0,
              LoanCount: portfolioAtGlanceData.length,
              status: loadingTypes.fulfilled,
            });
          }
        } else {
          setFormData({
            ...formData,
            segment: 100,
            LoanCount: portfolioAtGlanceData.length,
            status: "No data",
          });
        }
      } catch (error) {
        if (error.name === "CanceledError") {
          console.error("Fetch request canceled", error.message);
        } else {
          console.error(error);
        }
      }
    };

    // portfolioAtGlanceData.length > 0 && fetchData();
    fetchData();
  }, [
    accountId,
    dispatch,
    // formData,
    kpis.portfolioBalance,
    portfolioAtGlanceData,
  ]);

  return (
    <div className="pt-5">
      {formData?.status && formData?.status === "No data" ? (
        <div className="row">
          <p>NO DATA AVAILABLE</p>{" "}
        </div>
      ) : // ) : formData.segment ? (
      formData?.status === loadingTypes.fulfilled &&
        portfolioAtGlanceStatus === loadingTypes.fulfilled ? (
        <div className="row">
          {" "}
          <div
            className="col-lg-7"
            role="button"
            onClick={() => navigate("/meter-details")}
          >
            <ReactSpeedometer
              width={300}
              height={150}
              needleHeightRatio={0.7}
              value={+formData.segment}
              customSegmentStops={[0, 25, 50, 75, 100]}
              maxValue={100}
              segmentColors={["#FFA500", "#FFFF00", "#90EE90", "#008000"]}
              currentValueText="Insurance Monitoring"
              customSegmentLabels={[
                {
                  text: "Poor",
                  position: "OUTSIDE",
                  color: "#000",
                },
                {
                  text: "Fair",
                  position: "OUTSIDE",
                  color: "#000",
                },
                {
                  text: "Good",
                  position: "OUTSIDE",
                  color: "#000",
                },
                {
                  text: "Excellent",
                  position: "OUTSIDE",
                  color: "#000",
                },
              ]}
              ringWidth={80}
              needleTransitionDuration={2222}
              needleTransition="easeElastic"
              needleColor={"#000"}
              valueTextFontSize={"0px"}
              labelFontSize={"20px"}
              valueTextFontWeight={"500"}
              paddingHorizontal={17}
              paddingVertical={17}
              textColor={"#000"}
            />
            {/* <Legend /> */}
          </div>
          <div className="col-lg-5">
            <MeterTable formData={formData} kpis={kpis} />
          </div>
        </div>
      ) : (
        <div className="row">
          <SpinnerBlock height={"10vh"} />
        </div>
      )}
    </div>
  );
};
let tabConfig = [
  {
    label: "Loan Aging",
    renderComponent: (_, formOptions) => <DoughnutChart />,
  },
  {
    label: "Insurance Expiry - Next 30 Days",
    renderComponent: (_, formOptions) => <Meter />,
  },
];
const MeterTable = ({ formData, kpis }) => {
  return (
    <Table bordered size="lg" style={{ fontSize: "16px" }}>
      <tbody>
        {/* <tr>
          <th style={{ background: "rgb(251, 251, 251)" }}>
            Portfolio balance
          </th>
          <td>
            <NumberFormat
              displayType="text"
              value={kpis.portfolioBalance}
              prefix={"$"}
              fixedDecimalScale={true}
              decimalScale={2}
              thousandSeparator={true}
            />
          </td>
        </tr> */}
        <tr>
          <th style={{ background: "rgb(251, 251, 251)" }}>
            Portfolio at risk
          </th>
          <td>
            {" "}
            <NumberFormat
              displayType="text"
              value={formData.finalPrincipal}
              prefix={"$"}
              fixedDecimalScale={true}
              decimalScale={2}
              thousandSeparator={true}
            />
          </td>
        </tr>
        <tr>
          <th style={{ background: "rgb(251, 251, 251)" }}>Risk Factor</th>
          <td>
            <NumberFormat
              displayType="text"
              value={formData.riskFactor}
              suffix={"%"}
              fixedDecimalScale={true}
              decimalScale={2}
              thousandSeparator={true}
            />
          </td>
        </tr>
        <tr>
          <th style={{ background: "rgb(251, 251, 251)" }}>Loan Count</th>
          <td>
            <NumberFormat
              displayType="text"
              value={formData.LoanCount}
              thousandSeparator={true}
            />
          </td>
        </tr>
        <tr>
          <th style={{ background: "rgb(251, 251, 251)" }}>Loans Insured</th>
          <td>
            <NumberFormat
              displayType="text"
              value={formData.loanInsured}
              thousandSeparator={true}
            />
          </td>
        </tr>
        <tr>
          <th style={{ background: "rgb(251, 251, 251)" }}>
            Loans expiring in next 30 days
          </th>
          <td>
            <NumberFormat
              displayType="text"
              value={formData.insExpirationWithin30Days}
              thousandSeparator={true}
            />
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
export function getSegment(percentage) {
  if (percentage >= 1 && percentage <= 5) {
    return 87.5;
  } else if (percentage >= 5 && percentage <= 15) {
    return 62.5;
  } else if (percentage >= 15 && percentage <= 25) {
    return 37.5;
  } else if (percentage > 25 && percentage <= 100) {
    return 12.5;
  } else if (percentage > 100) {
    return 0;
  } else {
    return "Invalid percentage";
  }
}
